import { jsx as _jsx } from "react/jsx-runtime";
import { useSettingShowSideBarV2UI } from "@faire/retailer-visitor-shared/settings/useSettingShowSideBarV2UI";
import { MenuItem } from "@faire/retailer-visitor-shared/views/settings/profile/MenuItem";
import { SideBarRenderer } from "@faire/retailer-visitor-shared/views/settings/profile/SideBarRenderer";
import { useMenuItems } from "@faire/retailer-visitor-shared/views/settings/useMenuItems";
import { Dropdown } from "@faire/web--source/slate/Dropdown";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import omit from "lodash/omit";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
export var SideBar = function(param) {
    var selected = param.selected, className = param.className;
    var showV2UI = useSettingShowSideBarV2UI();
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    var push = useHistory().push;
    var menuItems = useMenuItems();
    return /*#__PURE__*/ _jsx("section", {
        className: className,
        children: isTabletAndBelow ? /*#__PURE__*/ _jsx("div", {
            style: {
                height: "42px"
            },
            children: /*#__PURE__*/ _jsx(Dropdown, {
                "data-test-id": "account_settings_dropdown",
                value: selected,
                options: menuItems.map(function(item) {
                    return omit(item, "path");
                }),
                onDropdownOpen: function() {
                    menuItems.forEach(function(menuItem) {
                        var _menuItem_handleOnVisible;
                        (_menuItem_handleOnVisible = menuItem.handleOnVisible) === null || _menuItem_handleOnVisible === void 0 ? void 0 : _menuItem_handleOnVisible.call(menuItem);
                    });
                },
                onSelect: function(param) {
                    var value = param.value;
                    var _selectedMenuItem_handleClick;
                    var selectedMenuItem = menuItems.find(function(item) {
                        return item.value === value;
                    });
                    var path = selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.path;
                    selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : (_selectedMenuItem_handleClick = selectedMenuItem.handleClick) === null || _selectedMenuItem_handleClick === void 0 ? void 0 : _selectedMenuItem_handleClick.call(selectedMenuItem);
                    if (path) {
                        push(path);
                    }
                }
            })
        }) : /*#__PURE__*/ _jsx(Menu, {
            children: showV2UI ? /*#__PURE__*/ _jsx(SideBarRenderer, {
                menuItems: menuItems,
                selected: selected
            }) : menuItems.map(function(menuItem) {
                return /*#__PURE__*/ _jsx(MenuItem, {
                    menuItem: menuItem,
                    isSelected: menuItem.value === selected
                }, menuItem.label);
            })
        })
    });
};
var Menu = styled.section.withConfig({
    componentId: "sc-31bf1de7-0"
})([
    "flex:1 1 0%;"
]);
